import History, { HistorySections } from './History';

export default History;
export { HistorySections };
